import { Type } from 'class-transformer';
import { ConveyanceClosingFeeRuleResultDto } from './conveyance-closing-fee-rule-result-dto';

export class ConveyanceCommunityClosingFeeRuleResultDto {
    communityId: number;
    communityName: string;

    @Type(() => ConveyanceClosingFeeRuleResultDto)
    closingFeeRules: ConveyanceClosingFeeRuleResultDto[];

    currentSellerClosingFeeDisplayText: string;
}
